import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { endpoints } from "../../../../../core/defaultValues";
import { clientQuery } from "../../../../../core/data/GraphQLApi";
import { resetALL } from "../../../../../.globals/redux/actions";
import { ExceptionManager } from "../../../../../core/logManager";

const INIT_STATE = {
  loadingCrews: false,
  crews: [],
  totalCrews: 0,
  error: null,
};

const route = "modules/manage/views/main/components/crewTab/redux/slice.";

const manageSearchCrews = createAsyncThunk(
  "manage/crewTab/manageSearchCrews",
  async ({ conditions, sort, limit, offset = 0 }, { rejectWithValue }) => {
    try {
      const response = await clientQuery(
        manageSearchCrews.query,
        {
          conditions,
          sort,
          limit,
          offset,
        },
        endpoints.GRAPHQL_GENERAL_V2
      );
      return response?.data || { items: [], total: 0 };
    } catch (exc) {
      ExceptionManager(exc, route, "searchCrews");
      return rejectWithValue(exc);
    }
  }
);

manageSearchCrews.query = `
    query ($conditions: [CrewSearchInput], $sort: [CrewSortInput], $limit: Int, $offset: Int) {
        data: searchCrews(
            conditions: $conditions
            sort: $sort
            limit: $limit
            offset: $offset
        ) {
            total
            items {
                id
                firstName
                lastName 
                unitId
                unit {
                  id
                  label
                }
            }
        }
    }
`;

export { manageSearchCrews };

//Slice
const manageCrewTabRedux = createSlice({
  name: "manage/crewTab",
  initialState: INIT_STATE,
  reducers: {
    reset(state, action) {
      return action.payload ? { ...state, ...action.payload } : INIT_STATE;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetALL, () => INIT_STATE);

    //manageSearchCrews
    builder.addCase(manageSearchCrews.pending, (state) => {
      state.loadingCrews = true;
    });
    builder.addCase(manageSearchCrews.fulfilled, (state, action) => {
      state.loadingCrews = false;
      state.crews = action.payload.items;
      state.totalCrews = action.payload.total;
    });
    builder.addCase(manageSearchCrews.rejected, (state, action) => {
      state.loadingCrews = false;
      state.error = action.payload;
    });
  },
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = manageCrewTabRedux;

// Extract and export each action creator by name
export const { reset } = actions;

// Export the reducer, either as a default or named export
export default reducer;
